module.exports = __webpack_public_path__ + "img/iStock-518886930 (copy).6ceb596e.jpg";